import { ReactNode } from 'react';
import { combineCls, fontSize, margin, textAlign, textColor, twCls } from 'style';

export interface TitleProps {
  className?: string;
  children?: ReactNode;
}

export const Title = ({ className, children }: TitleProps): JSX.Element => {
  return (
    <h1
      className={combineCls(
        twCls(
          textColor('text-grey-900'),
          margin('mt-2'),
          textAlign('text-center'),
          fontSize('text-2xl'),
        ),
        className,
      )}
    >
      {children}
    </h1>
  );
};
